// extracted by mini-css-extract-plugin
export default {"descriptions":"style_descriptions__eifRC","description":"style_description__oPkb0"};